import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import debounce from 'lodash.debounce'
import classnames from 'classnames'

import { getScaleAndCoverage } from '_services/data-explorer'
import { useEventFeedsContext } from '../../context/index.jsx'
import TotalEventsCard from './counts-card/index.jsx'
import { logErrorAsync } from '../../../../lib/utility.js'
import UniqueCountsCards from './unique-counts-cards/index.jsx'
import { useIsSnapshot } from '../../manage-component/index.jsx'
import useDataPreview from '../data-preview/hooks/useDataPreview.js'
import DataPreview from './data-preview/index.jsx'
import { TYPE_PREBUILT_ATTRIBUTES_V2 } from '../../wizard/index.jsx'

import './styles.scss'
import { Card, CARD_THEME } from '@st-operations/uikit/src/v2/index.js'

const Statistics = () => {
  const {
    data: { type, filters, snapshot },
    permissions: {
      tabs: { scale_and_coverage },
    },
  } = useEventFeedsContext()
  const predictors = type === TYPE_PREBUILT_ATTRIBUTES_V2
  const {
    loading: loadingDataPreview,
    filteredColumns,
    tableColumns,
    tableData,
    objectData,
    totalEvents,
  } = useDataPreview(undefined, predictors)
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)
  const isSnapshot = useIsSnapshot()

  useEffect(() => {
    async function getScale() {
      try {
        setLoading(true)
        const response = isSnapshot
          ? snapshot.scaleAndCoverage
          : await getScaleAndCoverage({ filters })
        setLoading(false)
        setData(response)
      } catch (error) {
        logErrorAsync(error)
        toast.error(error.message)
      }
    }

    if (filters) getScale()
  }, [filters])

  const containerRef = useRef(null)
  const [responsive, setResponsive] = useState()

  const handleResize = debounce(() => {
    const container = containerRef.current
    if (container) {
      const width = container.offsetWidth
      setResponsive(width < 1000)
    }
  }, 100)

  useLayoutEffect(() => {
    handleResize()
  }, [])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const hasPermission = (item) => {
    return scale_and_coverage.items.includes(item) || scale_and_coverage.items.includes('all')
  }

  return (
    <div
      ref={containerRef}
      className={classnames(
        'scale-and-coverage__scale',
        { responsive },
        !hasPermission('data_preview') && 'responsive two-rows',
        { 'scale-and-coverage__scale--predictors': predictors }
      )}
    >
      {/* eslint-disable-next-line jsx-control-statements/jsx-use-if-tag */}
      {hasPermission('events') && <TotalEventsCard className="scale-and-coverage__events" />}
      {hasPermission('unique_counts') && !predictors && (
        <UniqueCountsCards data={data} loading={loading} />
      )}
      {predictors && (
        <Card component="section" theme={CARD_THEME.NO_SHADOW} className="unique-counts-cards">
          {/* <HistogramForm /> */}
          TODO: ATTENTION, CHECK IF SOMETHING HERE IS NEEDED IF YOU SEE THIS
        </Card>
      )}
      {hasPermission('data_preview') && (
        <DataPreview
          loadingDataPreview={loadingDataPreview}
          filteredColumns={filteredColumns}
          tableColumns={tableColumns}
          tableData={tableData}
          objectData={objectData}
          totalEvents={totalEvents}
          loading={loading}
        />
      )}
    </div>
  )
}

export default React.memo(Statistics)
